module.exports = __webpack_public_path__ + "static/media/ShakeItUp.ffee18f3.png";